import React from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { messageToAccountantActions } from '@services'

import { useCommunicationMode } from '@hooks'

import { CompanyBasedIntercomInitializer } from '@components/Intercom'

import { COMMUNICATION_MODE_HUBSPOT } from '@constants'

import { SHOW_FLOATING_SUPPORT_LAUNCHER } from './constants'
import { HubSpotLauncherStyle } from './HubSpotLauncherStyle'
import { MessageToAccountantFab } from './MessageToAccountantFab'
import { MessageToAccountantSlideOver } from './MessageToAccountantSlideOver'

function ConnectedMessageToAccountantSlideOver() {
  const open = useSelector((state: Store) => state.messageToAccountant.isSlideOverOpen)
  const dispatch = useDispatch()

  const onOpenChange = React.useCallback(
    (isOpen: boolean) => dispatch(messageToAccountantActions.setSlideOverOpen.request(isOpen)),
    [dispatch]
  )

  return <MessageToAccountantSlideOver open={open} onOpenChange={onOpenChange} />
}

interface SupportChannelRootProps {
  /** Mirrors the navbar's own launcher flag: a page without the envelope in its header gets none in the corner. */
  withFloatingLauncher?: boolean
}

export function SupportChannelRoot({ withFloatingLauncher = false }: SupportChannelRootProps) {
  const communicationMode = useCommunicationMode()

  return (
    <>
      <CompanyBasedIntercomInitializer />
      {communicationMode === COMMUNICATION_MODE_HUBSPOT && (
        <>
          <ConnectedMessageToAccountantSlideOver />
          {withFloatingLauncher && (
            <>
              {SHOW_FLOATING_SUPPORT_LAUNCHER && <MessageToAccountantFab />}
              <HubSpotLauncherStyle />
            </>
          )}
        </>
      )}
    </>
  )
}
